<template>
    <div class="the-footer">
        <div class="f-wrapper">
            <div>
                <a href="/kontakty">
                    <img src="icons/envelope.png" alt="mail" class="f-ico">
                </a>                
                <span style="color: white; padding-left: 10px; padding-right: 15px;">aeroklub@lkkm.cz</span>
            </div>
            <div>
                <a href="/kontakty">
                    <img src="icons/pin.png" alt="contact" class="f-ico">
                </a>
                <span style="color: white; padding-left: 10px; padding-right: 15px;">Na Hrázi 1148, Kroměříž 767 01</span>                
            </div>

            <div>
                <img src="icons/copyright.png" alt="copyright" class="f-ico" >
                <span style="color: white; padding-left: 10px; padding-right: 15px;">Aeroklub Kroměříž 2022</span>                
            </div>
        </div>
        
        
    </div>
    
</template>

<script>
export default {
    name: "TheContact"
}
</script>

<style>

.f-wrapper{
    /* max-width: 90%; */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: wrap;
}

.f-ico{
    height: 20px;
    /* padding-right: 15px;
    padding-left: 20px; */
    filter: invert(1);
    transition: transform .2s;
}
.f-ico:hover{
    transform: scale(1.3);
}


.the-footer{
    display: flex;
    /* background: rgb(189, 190, 192); */
    width: 100%;
    /* height: 70px; */
    padding: 20px;

    background: rgb(22, 22, 22);
    justify-content: center;
    align-items: center;
}
</style>
